import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { conElSistema, sinElSistema } from '../data/comparativa';
export function Comparativa() {
  return <section aria-labelledby="comparativa-titulo" className="w-full bg-surface px-6 py-20" data-id="element-75" data-mp="kb7jr0tj8uyq">
      <div className="mx-auto max-w-content" data-id="element-76" data-mp="oct2v3wnu5hd">
        <div className="text-center" data-id="element-77" data-mp="tab4e98clifc">
          <h2 id="comparativa-titulo" className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-78" data-mp="tbcmgxns756k">
            ¿Te identificás con alguna de estas situaciones?
          </h2>
          <p className="mt-4 text-muted" data-id="element-79" data-mp="136o69ue1r2l6">Si respondiste sí a una sola, este sistema fue creado para vos.</p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-80" data-mp="17zh9uexs44vo">
          <div className="rounded-3xl border border-edge bg-canvas p-8" data-id="element-81" data-mp="1c0izq55t34kz">
            <h3 className="font-display text-xl font-bold text-ink" data-id="element-82" data-mp="1gzdpxs63rvf4">Sin el sistema</h3>
            <ul className="mt-6 space-y-4" data-id="element-83" data-mp="1gxj7ckib0fe7">
              {sinElSistema.map(item => <li key={item} className="flex items-start gap-3" data-id="element-84" data-mp="1lwcii6a4bub7">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-edge" data-id="element-85" data-mp="l0xg4iv2druh">
                    <XIcon className="h-3 w-3 text-brand-800" aria-hidden="true" data-id="element-86" data-mp="fzq9wo8kl0px" />
                  </span>
                  <span className="text-sm leading-snug text-muted" data-id="element-87" data-mp="c1k5vnz48z8p">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-brand-200 bg-soft p-8" data-id="element-88" data-mp="13qvmmuj7rcw0">
            <h3 className="font-display text-xl font-bold text-ink" data-id="element-89" data-mp="zpaf7opg7qt7">Con el Mega Pack Manicuría sin esclaviud</h3>
            <ul className="mt-6 space-y-4" data-id="element-90" data-mp="uxscav3v7g5l">
              {conElSistema.map(item => <li key={item} className="flex items-start gap-3" data-id="element-91" data-mp="pzh1oi5qx1mb">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-500" data-id="element-92" data-mp="px4nmg33zbej">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-93" data-mp="1inwi994izrzr" />
                  </span>
                  <span className="text-sm font-medium leading-snug text-body" data-id="element-94" data-mp="21keunpoye58k">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}